import { AppBar as MuiAppBar, Toolbar } from '@mui/material';

export const AiAppBar = ({ children }) => {
  return (
    <MuiAppBar elevation={0} position="static" sx={{ zIndex: 'drawer', bgcolor: 'background.paper', boxShadow: 4 }}>
      <Toolbar sx={{ gap: 2 }}>{children}</Toolbar>
    </MuiAppBar>
  );
};

export default AiAppBar;
